module.exports = __webpack_public_path__ + "img/bms-01-text.92497312.png";